import {useEffect, useState} from "react";
import {Alert, Button, Col, FloatButton, Form, message, Radio, Row, Space, Spin, Tooltip} from "antd";
import './style.scss'
import {useHistory} from "react-router-dom";
import {ACCOUNT_TYPE, COMMON_DROPDOWN, PARAMETER_LIST} from "../../util/Constants";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {LogoutOutlined} from "@ant-design/icons";
import keycloak from "../../security/KeyclockConfig";
import customerService from "../../service/customerService";
import {homeLogo, lets_start_page_img, xappHomeLogo} from '../../../AppImageConst';
import {MSG_NO_ACCOUNT_TYPE_LIST} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";

const AccountType = () => {
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";
    const history = useHistory();
    const [accountTypeList, setAccountTypeList] = useState<DropdownListDto[]>([]);
    const [accountType, setAccountType] = useState(1);
    const [isCanContinue, setIsCanContinue] = useState(false);
    const [formValue, setFormValue] = useState<{
        accountType: number,
        referenceNumber: string | undefined,
        preferredOption: string | undefined
    }>({
        accountType: 0,
        referenceNumber: undefined,
        preferredOption: undefined
    });
    const [isIndividualAccountDisabled, setIndividualAccountDisabled] = useState(false);
    const [isCanDisableContinue, setCanDisableContinue] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [referenceNumber, setReferenceNumber] = useState<string | undefined>(undefined);
    const [form] = Form.useForm();

    useEffect(() => {
        onLoad();
    }, [])

    const onLoad = () => {
        loadReference();
        loadAccountTypes();
    }

    const loadAccountTypes = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.ACCOUNT_TYPE,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setAccountTypeList(res.data.results.activeItemList)
                setIsCanContinue(true);
            } else {
                message.error(MSG_NO_ACCOUNT_TYPE_LIST).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const loadReference = () => {
        setCanDisableContinue(true)
        setLoading(true)
        customerService.getJointReferenceNumberByUsername().then(res => {
            setReferenceNumber(res.data.results)
            if (res.data.results !== undefined) {
                form.setFieldsValue({accountType: ACCOUNT_TYPE.JOINT_ACCOUNT});
                setIndividualAccountDisabled(true)
                setAccountType(ACCOUNT_TYPE.JOINT_ACCOUNT)
                setLoading(false)

            } else {
                form.setFieldsValue({accountType: ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT});
                setIndividualAccountDisabled(false)
                setAccountType(ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT)
                setLoading(false)

            }
            setCanDisableContinue(false)
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setLoading(false)

        })
    }

    const onChange = (e: Event) => {
        setAccountType(+(e.target as HTMLInputElement).value)
    };

    const onContinue = () => {
        if (accountType === ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT) {
            history.push('/create-individual-account', formValue)
        } else {
            history.push('/create-joint-account', formValue)
        }
    }

    const logout = (e: any) => {
        if (keycloak.authenticated) {
            // keycloak.logout({redirectUri: `${redirectUri}`})
            keycloak.logout({redirectUri: window.location.origin});
        }
    };
    const [isDivVisible, setIsDivVisible] = useState(true);

    const toggleDiv = (values: any) => {
        values.accountType = accountType;
        values.preferredOption = referenceNumber ? true : false;
        values.referenceNumber = referenceNumber
        setFormValue(values)
        setIsDivVisible(prevState => !prevState);
    };

    const IndividualStepList = () => {
        return <div>
            <div className="step-list">
                <div className="step-list-item">
                    <span className="step-list-number">
                        1
                    </span>
                    <span className="step-lit-description">
                        Personal Information
                    </span>
                </div>

                <div className="step-list-item">
                    <span className="step-list-number">
                        2
                    </span>
                    <span className="step-lit-description">
                        Residential Information
                    </span>
                </div>

                <div className="step-list-item">
                    <span className="step-list-number">
                        3
                    </span>
                    <span className="step-lit-description">
                        Investment Information
                    </span>
                </div>

                <div className="step-list-item">
                    <span className="step-list-number">
                        4
                    </span>
                    <span className="step-lit-description">
                        Bank Information
                    </span>
                </div>

                <div className="step-list-item">
                    <span className="step-list-number">
                        5
                    </span>
                    <span className="step-lit-description">
                        Other Information
                    </span>
                </div>

                <div className="step-list-item">
                    <span className="step-list-number">
                        6
                    </span>
                    <span className="step-lit-description">
                        Attachments and Supporting Information
                    </span>
                </div>

                <div className="step-list-item">
                    <span className="step-list-number">
                        7
                    </span>
                    <span className="step-lit-description">
                        Acknowledgment Information
                    </span>
                </div>
                {accountType === ACCOUNT_TYPE.JOINT_ACCOUNT && !formValue.referenceNumber ?
                    <div className="step-list-item">
                        <span className="step-list-number">
                            8
                        </span>
                        <span className="step-lit-description">
                            Second Applicant's Information
                        </span>
                    </div>
                    : <></>}
            </div>
        </div>;
    };
    const LeftSideCommonContent = () => {
        return <div style={{width: '100%'}}>
            <Col span={24} className='left-side-title-container'>
                <h1 className='left-side-main-title'>Manage</h1>
                <h1 className='left-side-main-title'>YOUR WEALTH</h1>
                <div className="header_divider"></div>
                <h2 className='left-side-sub-title'>- No paperwork, No stress - </h2>
            </Col>
        </div>;
    };

    return (
        <>
            <Tooltip title="Sign Out"><FloatButton icon={<LogoutOutlined/>} type="primary" onClick={logout}/></Tooltip>
            <div className='account_type_screen_main'>
                <div className={`${isDivVisible ? 'visible' : 'hidden'}`}>
                    <Row gutter={0} className='main-row'>
                        <Col lg={12} md={{span: 0}} sm={{span: 0}} hidden className='left-side-main-container'>
                            <Row gutter={0}>
                                <Col span={24}>
                                    <div className="clip-path-img">
                                        <div className='clip-path-img-container text-center'>
                                            <img src={xappHomeLogo} alt="logo" className={'w-20'}/>
                                        </div>
                                    </div>
                                </Col>
                                <LeftSideCommonContent/>
                            </Row>
                        </Col>
                        <Col lg={12} md={24} sm={24} className={'account_type_col'}>
                            <Spin spinning={isLoading}>
                                <div className='account_type_container'>
                                    <h1 className='main-header'>Account Type</h1>
                                    <h5 className='sub-header'>Tell us the account type you intend to open</h5>
                                    <div className='select-type-screen'>
                                        <Form
                                            layout={"vertical"}
                                            initialValues={{remember: true}}
                                            onFinish={toggleDiv}
                                            form={form}
                                        >
                                            <Row>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        name={'accountType'}>
                                                        <Radio.Group
                                                            className='radio_group_set account_type_custom_radio_btn'
                                                            defaultValue={1}>
                                                            <Space direction="vertical" onChange={onChange}>
                                                                {accountTypeList.map((data: DropdownListDto) => {
                                                                    return <Radio value={data.value}
                                                                                  disabled={ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT == data.value ? isIndividualAccountDisabled : false}>{data.label}</Radio>
                                                                })}
                                                            </Space>
                                                        </Radio.Group>

                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    {ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT === accountType ?
                                                        <Alert className='account_type_doc_info'
                                                               message="Please keep the below documents ready"
                                                               description={
                                                                   <ol>
                                                                       <li>National Identity Card (NIC)/ Drivers
                                                                           License/
                                                                           Passport
                                                                       </li>
                                                                       <li>If your permanent address differs from your
                                                                           NIC,
                                                                           you will need a
                                                                           recently
                                                                           dated residency document(Utility Bill within
                                                                           6 months)
                                                                       </li>
                                                                       <li>Proof to verify your bank account details
                                                                           (Passbook/ Online Banking
                                                                           Confirmation)
                                                                       </li>
                                                                   </ol>}
                                                               type="info"/>
                                                        : ACCOUNT_TYPE.JOINT_ACCOUNT === accountType ?
                                                            <div>
                                                                <Alert className='account_type_doc_info'
                                                                       message="Please keep the below documents ready"
                                                                       type="info" description={
                                                                    <ol>
                                                                        <li>National Identity Card (NIC)/ Drivers
                                                                            License/
                                                                            Passport
                                                                        </li>
                                                                        <li>If your permanent address differs from your
                                                                            NIC,
                                                                            you will need a
                                                                            recently
                                                                            dated residency document(Utility Bill within
                                                                            6
                                                                            months)
                                                                        </li>
                                                                        <li>Proof to verify your bank account details
                                                                            (Passbook/ Online Banking
                                                                            Confirmation)
                                                                        </li>
                                                                    </ol>}
                                                                />
                                                            </div>
                                                            : ACCOUNT_TYPE.CORPORATE_ACCOUNT === accountType ?
                                                                <Alert className='account_type_doc_info'
                                                                       message="Please keep the below documents ready"
                                                                       type="info" description={
                                                                    <ol>
                                                                        <li>National Identity Card (NIC)/ Drivers
                                                                            License/ Passport
                                                                        </li>
                                                                        <li>If your permanent address differs from your
                                                                            NIC,
                                                                            you will need a
                                                                            recently
                                                                            dated residency document(Utility Bill within
                                                                            6 months)
                                                                        </li>
                                                                        <li>Proof to verify your bank account details
                                                                            (Passbook/ Online Banking
                                                                            Confirmation)
                                                                        </li>
                                                                    </ol>}
                                                                />
                                                                : <></>
                                                    }
                                                </Col>
                                                <Col xxl={{span: 12, offset: 6}} xl={{span: 12, offset: 6}}
                                                     lg={{span: 12, offset: 6}} md={{span: 12, offset: 6}}
                                                     sm={{span: 24, offset: 0}} className='continue-btn-col'>
                                                    <Form.Item className='form-item-btn'>
                                                        <Button htmlType="submit" className='custom-btn-primary'
                                                                type="primary" disabled={isCanDisableContinue}>
                                                            Continue
                                                        </Button>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </div>
                            </Spin>
                        </Col>
                    </Row>
                </div>

                <div className={`${!isDivVisible ? 'visible' : 'hidden'}`}>
                    <Row>
                        <Col lg={{span: 12}} md={{span: 0}} sm={{span: 0}} xs={{span: 0}}
                             className='left-side-main-container'>
                            <Row gutter={0}>
                                <Col span={24}>
                                    <div className="clip-path-img">
                                        <div className='clip-path-img-container text-center'>
                                            <img src={xappHomeLogo} alt="logo" className={'w-20'}/>
                                        </div>
                                    </div>
                                </Col>
                                <LeftSideCommonContent/>
                            </Row>
                        </Col>
                        <Col lg={{span: 12}} md={{span: 0}} sm={{span: 0}} xs={{span: 0}} className='lets-start-col'>
                            <div>
                                <div className='lets-start-container'>
                                    <h1 className='main-header'>Let's Start!</h1>
                                    <h5 className='sub-header'>Create your NDBW account
                                        in {accountType === ACCOUNT_TYPE.JOINT_ACCOUNT && !formValue.referenceNumber ? '8' : '7'} easy
                                        steps</h5>

                                    <Row>
                                        <Col xxl={{span: 18, offset: 2}} lg={24} md={{span: 24}} sm={{span: 24}}
                                             xs={{span: 24}}>
                                            <IndividualStepList/>
                                        </Col>
                                        <Col xxl={{span: 12, offset: 6}} xl={{span: 12, offset: 6}}
                                             lg={{span: 12, offset: 6}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}
                                             className='continue-btn-col'>
                                            <Form.Item className='form-item-btn'>
                                                <Button className='custom-btn-primary' type="primary"
                                                        onClick={isCanContinue ? () => onContinue() : undefined}>
                                                    Get Started
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                        <Col xl={{span: 0}} lg={{span: 0}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                            <div className='lets-start-container-mobile select-type-screen'>
                                <Row className='lets-row-1'>
                                    <Col span={24}>
                                        <div className="clip-path-img">
                                            <div className='clip-path-img-container'>
                                                <img src={lets_start_page_img} alt="logo"/>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <h1>Let's Start!</h1>
                                        <h2>Create your NDBW account
                                            in {accountType === ACCOUNT_TYPE.JOINT_ACCOUNT && !formValue.referenceNumber ? '8' : '7'} easy
                                            steps</h2>
                                    </Col>
                                    <Col span={24}>
                                        <IndividualStepList/>
                                    </Col>
                                    <Col xl={{span: 10, offset: 7}} lg={{span: 12, offset: 6}}
                                         md={{span: 24, offset: 0}} className='get-started-btn'>
                                        <Form.Item className='form-item-btn'>
                                            <Button className='custom-btn-primary' type="primary"
                                                    onClick={isCanContinue ? () => onContinue() : undefined}>
                                                Get Started
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>


    )

}
export default AccountType;

